const post3 = {
  id: 3,
  directory: 'react-d3-basics',
  publishDate: '2-15-2020',
  mediaType: 'image',
  catagories: [],
  ImageThumb: '3-react-d3-thumb.png',
  ImageLarge: 'https://picsum.photos/900/400/?image=90',
  shortDescription: 'ReactJS + D3',
  description: 'description of post',
  url: 'http://www.andressbarnes.com',
  body:
    "<h1>Nature's Sandbox</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>"
};

export default post3;
